import { AdjustedLine, ModifierContext } from "../../modifier-models";
import { BaseRule } from "../../rule-base";

export class RulePhysio0008 extends BaseRule {
    name = 'Physio 0008: 50% reduction for additional procedures';

    run(line: AdjustedLine, ctx: ModifierContext, autoApply: boolean): void {
        if (line.code !== '0008') return;

        if (autoApply) {
            // Apply 50% reduction to the line
            line.adjustedUnits = line.adjustedUnits * 0.5;
            if (line.adjustedRand) {
                line.adjustedRand = +(line.adjustedRand * 0.5).toFixed(2);
            }
            line.trace.push('Physio 0008: 50% reduction applied');
        } else {
            line.suggestions = line.suggestions || [];
            line.suggestions.push({
                ruleCode: '0008',
                message: 'Only 50% of the fee for these additional procedures may be charged',
                kind: 'overwrite',
                unitsDelta: line.adjustedUnits * 0.5
            });
        }
    }

    apply(lines: AdjustedLine[], ctx: ModifierContext, warn: string[]): AdjustedLine[] {
        lines.forEach(line => {
            if (line.code === '0008') {
                line.adjustedUnits = line.adjustedUnits * 0.5;
                if (line.adjustedRand) {
                    line.adjustedRand = +(line.adjustedRand * 0.5).toFixed(2);
                }
                line.trace.push('Physio 0008: 50% reduction applied');
            }
        });
        return lines;
    }
} 